export const chargeData = async (props, payload) => {
    const {
            getUserData,
            getBalanceUser,
            getConsolidateUser,
            getParams,
            getQuotas,
            getDeviceData,
            getEntitiesCore,
            //getCollectionsOtherServices,
            getCertificatesCore,
            getApplicationMenu,
            // getAgreements,
            // getAgreementsSwitchServices
            getUserPermissions,
            getStates,
            getCompany
        } = props
    try {
        const userData = await getUserData(payload.user.identification)
        await getCompany(payload.user.company)
        getDeviceData(payload.user.id)
        await getParams()
        const { data } = userData.payload
        await getConsolidateUser({NumeroCliente: data.numeroCliente})
        //console.log(data)
        await getBalanceUser({NumeroCliente: data.numeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        //await getElectricCompaniesCore()
        await getEntitiesCore()
        // await getAgreements()
        // await getAgreementsSwitchServices()
        //await getFoundations()
        //await getCollectionsOtherServices()
        await getCertificatesCore()
        await getApplicationMenu()
        //const getInfoCreditsCore = await getInfoCredits({NumeroCliente: data.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        //const { data: infoCredits } = getInfoCreditsCore.payload
       // await getTypeCredits({ SecuencialEmpresa: 1 })
        //if (infoCredits.length > 0) {
            // getCredits({SecuencialPrestamo:infoCredits[0].Secuencial, SecuencialEmpresa: 1 })
            //await getAditionalCredits({SecuencialPrestamo:infoCredits[0].Secuencial })
        //}
        //const getDepositsCore = await getDeposits({ NumeroCliente: data.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true})
        //const { data: infoDeposits } = getDepositsCore.payload
        //if (infoDeposits.length > 0) {
            // await getDepositsAditional({SecuencialDeposito: infoDeposits[0].Secuencial })
            // await getDepositsMovements({SecuencialDeposito: infoDeposits[0].Secuencial, FechaInicio: '', FechaFin: '', SecuencialEmpresa: 1})
        //}
        await getUserPermissions()
        await getStates()
        await getQuotas({cedule: data.identificacion})
        /* if (quotaExist.payload.length === 0) {
            feathersCreateData('quotas', {cedule: payload.user.vusk, daily: '40000', weekly: '0', monthly: '10000' })()
        } */
        //await getSiim()
        return Promise.resolve('Data cargada correctamente')
    } catch (error) {
        //console.log('error de loading core',JSON.stringify(error))
        return Promise.reject(error);
    }

}
export default chargeData
